import React from "react";
import { twMerge } from "tailwind-merge";

const Button = React.forwardRef(
    (
        { children, type = "button", className, overrideClasses, ...props },
        ref
    ) => {
        const defaultClassNames =
            "flex gap-x-2 items-center justify-center bg-blue-500 hover:bg-blue-500 focus:bg-blue-500 text-white rounded-lg px-5 py-2 font-semibold";
        const classNames = overrideClasses
            ? overrideClasses
            : twMerge(defaultClassNames, className ? className : "");

        return (
            <button type={type} ref={ref} className={classNames} {...props}>
                {children}
            </button>
        );
    }
);

export default Button;
